import { EditorConfig } from '@ckeditor/ckeditor5-core';
import { Essentials, Bold, List, Heading } from 'ckeditor5';

export const ADMIN_CLIENT_CKEDITOR_CONFIG: EditorConfig = {
  licenseKey: 'GPL',
  extraPlugins: [Essentials, Bold, List, Heading],
  toolbar: ['heading', '|', 'bold', 'bulletedList', 'numberedList'],
  heading: {
    options: [
      {
        model: 'heading1',
        view: 'h5',
        title: 'Heading',
        class: 'ck-heading_heading3'
      },
      { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' }
    ]
  }
};
